var sidebar, errorModal;
var updateAnnouncementsTime = new Date(), updateIssueTime = new Date();
var updateCheckInterval = 20000;
var updateAudio = $("#update-alert");
var announcementCount = 0, issueCount = 0;

/** CUSTOM AJAX HANDLERS AND ERRORS
 ----------------------------------------- */
$(document).ajaxSuccess(function (event, xhr, options, data) {
	//options.dataType.toLowerCase() == 'json' &&
	//console.log(options);
	if (data.hasOwnProperty("portalerror") && !options.url.endsWith("snmp")) {
		ajaxError(data.portalerror);
	}
});
$(document).ajaxError(function (event, xhr, settings, error) {
	if (xhr.statusText != 'abort') {
		ajaxError(xhr.responseText);
	}
});
$(document).ajaxSend(function (event, xhr, settings) {
	if (settings.type.toLowerCase() == 'post') {
		if (settings.data.length > 0) {
			settings.data += "&";
		}
		settings.data += "_token=" + token();
	}
});

/**
 * Shows a modal with the specified error.
 * @param html
 */
function ajaxError(html) {
	$(errorModal).find(".modal-content").html(html);
	$(errorModal).modal('show');
}

/** SOCKET IO
 -------------------------------------- */
var socket = io(":3000");

/** TOKEN
 ------------------------------------- */
function token() {
	return $("meta[name='token']").attr("content");
}

/** Colors
 ------------------------------------*/
var bsColorSuccess = "#18BC9C";
var bsColorInfo = "#3498DB";
var bsColorDanger = "#F39C12";
var bsColorWarning = "#18BC9C";

/** Session
 ----------------------------------- */
function Session() {
}
Session.go = function (action, data, callback) {
	$.ajax({
		url: base_url + "/session/" + action,
		method: 'POST',
		data: {data: data, _token: token()},
		dataType: 'json',
		success: function (json) {
			if (json.hasOwnProperty("error")) {
				// console.error(json.error);
			} else {
				// console.log(action + " data");
				// console.log(data);
			}
			
			if (typeof callback == 'function') {
				callback();
			}
		},
		error: function (xhr, status, error) {
			// console.error("AJAX Error: " + status, error);
		}
	});
};
Session.put = function (data, callback) {
	Session.go('put', data, callback);
};
Session.push = function (data, callback) {
	Session.go('push', data, callback);
};
Session.pull = function (data, callback) {
	Session.go('pull', data, callback);
};
Session.forget = function (data, callback) {
	Session.go('forget', data, callback);
};
Session.get = function (data, callback) {
	Session.go('get', data, callback);
};

$("#slidechecker").bootstrapSwitch({
    onText: 'Dashes',
    offText: 'Colons'
});

function doTHETHING() {
	var text = document.getElementById("macmaker").value;
	var what = document.getElementById("slidechecker").checked;

	text = text.toUpperCase();

	if(what) {
		if(text.indexOf("-") >= 0) {
			text = text.replace("-", "");
			text = text.replace("-", "");
			text = text.replace("-", "");
			text = text.replace("-", "");
			text = text.replace("-", "");
		} else {
			text = text.replace(":", "");
			text = text.replace(":", "");
			text = text.replace(":", "");
			text = text.replace(":", "");
			text = text.replace(":", "");
			text = text.substring(0, 2) + '-' + text.substring(2, 4) + '-' + text.substring(4, 6) + '-' + text.substring(6, 8) + '-' + text.substring(8, 10) + '-' + text.substring(10, 12);
		}
	} else {
		if(text.indexOf(":") >= 0) {
			text = text.replace(":", "");
			text = text.replace(":", "");
			text = text.replace(":", "");
			text = text.replace(":", "");
			text = text.replace(":", "");
		} else {
			text = text.replace("-", "");
			text = text.replace("-", "");
			text = text.replace("-", "");
			text = text.replace("-", "");
			text = text.replace("-", "");
			text = text.substring(0, 2) + ':' + text.substring(2, 4) + ':' + text.substring(4, 6) + ':' + text.substring(6, 8) + ':' + text.substring(8, 10) + ':' + text.substring(10, 12);
		}
	}
	document.getElementById("macmaker").value = text;

	var copyText = document.getElementById("macmaker");
	copyText.select();
  	copyText.setSelectionRange(0, 99999);
  	document.execCommand("copy");
}

var sidebarState = Session.get('sidebarState', function () {
	if (typeof sidebarState == 'undefined') {
		sidebarState = {
			sidebar: $(sidebar).hasClass("mini"),
			categories: []
		};
		$("#sidebar-wrapper .app-list").each(function () {
			var category_id = $(this).data("category");
			sidebarState.categories[category_id] = $(this).hasClass("in");
		});

		Session.put({sidebarState: sidebarState});
	}
});

function fuckyou(e) {
	e.preventDefault();

	var element = $(this);
	var sessionData = {};

	var toggleSidebar = false;
	var toggleCategory = false;

	if ($(element).attr("id") == "toggle-sidebar") {
		toggleSidebar = true;
		sidebarState.sidebar = !$(sidebar).hasClass("mini");
	}
	else if ($(element).hasClass("category-toggle")) {
		toggleCategory = true;
		var category_id = $(this).data("category");
		sidebarState.categories[category_id] = !$(this).parent().find("ul.app-list").hasClass("in");
	}

	if (sidebarState.sidebar) {
		for (var i = 0; i < sidebarState.categories.length; i++) {
			sidebarState.categories[i] = false;
		}
		$("#sidebar-wrapper .app-list").each(function () {
			$(this).collapse('hide');
		});
	}

	Session.put({sidebarState: sidebarState}, function () {
		if (toggleSidebar)
			$(sidebar).toggleClass('mini');
		if (toggleCategory && !sidebarState.sidebar)
			$(element).parent().find("ul.app-list").collapse('toggle');
	});
}

$(document).ready(function () {
	//Variables
	sidebar = $("#sidebar-wrapper");
	errorModal = $("#error-modal");

	//Listeners
	$("#toggle-sidebar").click(fuckyou);
	$("#sidebar-wrapper .category-toggle").click(fuckyou)

	//Announcements and Alerts
	checkForAnnouncements();
	checkForIssues();
	$("#announcement-dropdown, #mobile-announcement-dropdown").parent().on("shown.bs.dropdown", openAnnouncementDropdown);
	$("#issue-dropdown, #mobile-issue-dropdown").parent().on("shown.bs.dropdown", openIssueDropdown);
});

Array.prototype.diff = function (a) {
	return this.filter(function (i) {
		return a.indexOf(i) < 0;
	});
};

/** Chart.js Global Config
 -----------------------------------*/
if (typeof Chart != 'undefined') {
	Chart.defaults.global = {
		animation: true,
		animationSteps: 60,
		animationEasing: "easeOutQuart",
		showScale: true,
		scaleOverride: false,
		scaleSteps: null,
		scaleStepWidth: null,
		scaleStartValue: null,
		scaleLineColor: "rgba(0,0,0,.1)",
		scaleLineWidth: 1,
		scaleShowLabels: true,
		scaleLabel: "<%=value%>",
		scaleIntegersOnly: true,
		scaleBeginAtZero: true,
		scaleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		scaleFontSize: 12,
		scaleFontStyle: "normal",
		scaleFontColor: "#666",
		responsive: true,
		maintainAspectRatio: false,
		showTooltips: true,
		customTooltips: false,
		tooltipEvents: ["mousemove", "touchstart", "touchmove"],
		tooltipFillColor: "rgba(0,0,0,0.8)",
		tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		tooltipFontSize: 14,
		tooltipFontStyle: "normal",
		tooltipFontColor: "#fff",
		tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		tooltipTitleFontSize: 14,
		tooltipTitleFontStyle: "bold",
		tooltipTitleFontColor: "#fff",
		tooltipYPadding: 6,
		tooltipXPadding: 6,
		tooltipCaretSize: 8,
		tooltipCornerRadius: 6,
		tooltipXOffset: 10,
		tooltipTemplate: "<%if (label){%><%=label%>: <%}%><%= value %>",
		multiTooltipTemplate: "<%= datasetLabel %> - <%= value %>",
		onAnimationProgress: function () {
		},
		onAnimationComplete: function () {
		},

		scaleShowGridLines: true,
		scaleGridLineWidth: 1,
		scaleShowHorizontalLines: true,
		scaleShowVerticalLines: true,
		barShowStroke: true,
		barStrokeWidth: 1,

		bezierCurve: true,
		bezierCurveTension: 0.4,
		pointDot: true,
		pointDotRadius: 4,
		pointDotStrokeWidth: 1,
		pointHitDetectionRadius: 20,
		datasetStroke: true,
		datasetStrokeWidth: 2,
		datasetFill: true,
	};
}

/** Loading
 -----------------------------------*/
function loading(show) {
	if (show)
		$("#app-loading").removeClass("hidden");
	else
		$("#app-loading").addClass("hidden");
}

/** Error
 ------------------------------------*/
function errorMsg(title, msg) {
	var errorBar = $("<div>", {
		class: "alert alert-danger animated fadeInDown",
		id: "errors",
		style: "position: absolute; top:0; z-index:1; width: 100%"
	});
	errorBar.append($("<strong>" + title + "</strong>"));
	errorBar.append($("<button>", {
		type: "button",
		class: "close",
		'data-dismiss': "alert"
	}));
	errorBar.find("button").append($("<span>&times;</span>", {
		'aria-hidden': "true"
	}));
	errorBar.append($("<ul>"));
	errorBar.find("ul").append($("<li>" + msg + "</li>"));
	// console.log(errorBar);
	$("#app-wrapper").append(errorBar);
}

/** Announcement & Alerts
 ------------------------------------*/
socket.on("portal:App\\Events\\AnnouncementHandler", function (data) {
	if (!$("#announcement-dropdown li[data-id='" + data.announcement.id + "']").length) {

		//Remove the no announcements thing
		$("#announcement-dropdown li:not(.announcement)").remove();
		$("#mobile-announcement-dropdown li:not(.announcement)").remove();

		//Add the new annoucement
		$("#announcement-dropdown").prepend(data.view);
		$("#mobile-announcement-dropdown").prepend(data.view);
		playAlert();

		announcementCount = $("#announcement-dropdown li.announcement:not(.acknowledged)").size();
		if (announcementCount > 0) {
			playAlert();
			$("#announcement-count small, #mobile-announcement-count small").text(announcementCount);
			$("#announcement-count, #mobile-announcement-count").addClass("badge-alert");
		}
		else if (count == 0) {
			$("#announcement-count small, #mobile-announcement-count small").text(announcementCount);
			$("#announcement-count, #mobile-announcement-count").removeClass("badge-alert");
		}
		else {
			$("#announcement-count small, #mobile-announcement-count small").text(announcementCount);
		}
	}
});

function checkForAnnouncements() {
	$.ajax({
		url: base_url + "/portal/announcements/check",
		dataType: 'html',
		success: function (html) {

			//If dropdown isn't open
			if (!$("#announcement-dropdown").parent().hasClass("open")) {
				// console.log("not open");

				//Update HTML
				$("#announcement-dropdown, #mobile-announcement-dropdown").html(html);

				//Get announcement size
				var count = $("#announcement-dropdown li.announcement").size();

				//To play a sound, or not to play a sound
				if (count > announcementCount) {
					playAlert();
					$("#announcement-count small, #mobile-announcement-count small").text(count);
					$("#announcement-count, #mobile-announcement-count").addClass("badge-alert");
				}
				else if (count == 0) {
					$("#announcement-count small, #mobile-announcement-count small").text(count);
					$("#announcement-count, #mobile-announcement-count").removeClass("badge-alert");
				}
				else {
					$("#announcement-count small, #mobile-announcement-count small").text(count);
				}

				//Update announcement count
				announcementCount = count;

				//Assign listeners
				$("#announcement-dropdown li.announcement a, #mobile-announcement-dropdown li.announcement a").click(openAnnouncement);
			}
			else {
				// console.log("open");
			}
		}
	});
}

function openAnnouncementDropdown() {
	var ids = [];
	$("#announcement-dropdown li.announcement").each(function () {
		ids.push($(this).data("id"));
	});

	if (ids.length > 0) {
		$.ajax({
			url: base_url + "/portal/announcements/acknowledge",
			dataType: 'json',
			method: 'POST',
			data: {
				ids: ids,
				_token: token()
			},
			success: function (json) {
				// console.log("success");
				announcementCount = 0;
				$("#announcement-count, #mobile-announcement-count").removeClass("badge-alert");
				$("#announcement-count small, #mobile-announcement-count small").text(0);
				$("#announcement-dropdown li.announcement:not(.acknowledged)").addClass("acknowledged");
			},
			error: function (xhr, status, error) {
				// console.log(xhr);
				// console.log(status);
				// console.log(error);
			}
		});
	}
}

function openAnnouncement() {
	// console.log("opened announcement");
}

socket.on("portal:App\\Events\\IssueHandler", function (data) {
	if (!$("#issue-dropdown li[data-id='" + data.issue.id + "']").length) {

		//Remove the no issues thing
		$("#issue-dropdown li:not(.issue)").remove();
		$("#mobile-issue-dropdown li:not(.issue)").remove();

		//Add the new annoucement
		$("#issue-dropdown").prepend(data.view);
		$("#mobile-issue-dropdown").prepend(data.view);
		playAlert();

		issueCount = $("#issue-dropdown li.issue:not(.acknowledged)").size();
		if (issueCount > 0) {
			playAlert();
			$("#issue-count small, #mobile-issue-count small").text(issueCount);
			$("#issue-count, #mobile-issue-count").addClass("badge-alert");
		}
		else if (count == 0) {
			$("#issue-count small, #mobile-issue-count small").text(issueCount);
			$("#issue-count, #mobile-issue-count").removeClass("badge-alert");
		}
		else {
			$("#issue-count small, #mobile-issue-count small").text(issueCount);
		}
	}
});

function checkForIssues() {
	$.ajax({
		url: base_url + "/noc/service-issue/check",
		dataType: 'html',
		success: function (html) {

			//If dropdown isn't open
			if (!$("#issue-dropdown").parent().hasClass("open")) {
				// console.log("not open");

				//Update HTML
				$("#issue-dropdown, #mobile-issue-dropdown").html(html);

				//Get issue size
				var count = $("#issue-dropdown li.issue").size();

				//To play a sound, or not to play a sound
				if (count > issueCount) {
					playAlert();
					$("#issue-count small, #mobile-issue-count small").text(count);
					$("#issue-count, #mobile-issue-count").addClass("badge-alert");
				}
				else if (count == 0) {
					$("#issue-count small, #mobile-issue-count small").text(count);
					$("#issue-count, #mobile-issue-count").removeClass("badge-alert");
				}
				else {
					$("#issue-count small, #mobile-issue-count small").text(count);
				}

				//Update announcement count
				issueCount = count;

				//Assign listeners
				$("#issue-dropdown li.issue a, #mobile-issue-dropdown li.issue a").click(openIssue);
			}
			else {
				// console.log("open");
			}
		},
		error: function (xhr, status, error) {
			errorMsg("AJAX Error: " + status, error);
		}
	});
}

function openIssueDropdown() {
	var ids = [];
	$("#issue-dropdown li.issue").each(function () {
		ids.push($(this).data("id"));
	});

	if (ids.length > 0) {
		$.ajax({
			url: base_url + "/noc/service-issue/acknowledge",
			dataType: 'json',
			data: {
				ids: ids
			},
			method: 'POST',
			success: function (json) {
				// console.log("success");
				issueCount = 0;
				$("#issue-count, #mobile-issue-count").removeClass("badge-alert");
				$("#issue-count small, #mobile-issue-count small").text(0);
			},
			error: function (xhr, status, error) {
				errorMsg("AJAX Error: " + status, error);
			}
		});
	}
}

function openIssue() {
	// console.log("opened issue");
}

//Start WOW
new WOW().init();

//Play alert
function playAlert() {
	$("#update-audio").get(0).play();
}